'use strict';

var hampers = require('./pages/product/hampers'),
	quickview = require('./quickview'),
	util = require('./util'),
	addToCart = require('./pages/product/addToCart');

function initQuickViewButtons() {
	$('.quickviewbutton').off('click');
	$('.quickviewbutton').on('click', function (e) {
		e.preventDefault();
		var quickViewURL = $(this).attr('href');
		var qty = $(this).closest('.grid-tile').find('.input-group-qty').val();
		var callback = null;
		if (!isNaN(qty)) {
			quickViewURL = util.appendParamToURL(quickViewURL, 'Quantity', qty);
			callback = hampers.initializeQuickview;
		}
		quickview.show({
			url: quickViewURL,
			source: 'quickview',
			callback: callback,
			dialogClass: $(this).hasClass('hamper-qv') ? 'hamper-qv quickview-dialog' : 'quickview-dialog'
		});
	});
}

function gridViewButtons() {
	$('.toggle-grid').off('click');
	$('.toggle-grid').on('click', 'i', function () {
		if (!$(this).hasClass('active')) {
			var isGridView;
			if ($(this).hasClass('list-view')) {
				isGridView = false;
			} else {
				isGridView = true;
			}
			gridViewToggle(isGridView);
			if ($('.toggle-grid .list-view').hasClass('active')) {
				$('.search-result-content').addClass('wide-tiles');
			} else {
				$('.search-result-content').removeClass('wide-tiles');
				$('.toggle-grid .list-view').removeClass('active');
				$('.tiles-container .product-tile').css('height', 'auto');
				$('.tiles-container .product-tile').syncHeight();
			}
		}
	});
}


function gridViewToggle(isGridView) {
	if (isGridView) {
		$('.toggle-grid .list-view').removeClass('active');
		$('.toggle-grid .grid-view').addClass('active');
	} else {
		$('.toggle-grid .grid-view').removeClass('active');
		$('.toggle-grid .list-view').addClass('active');
	}
}

/**
 * @private
 * @function
 * @description Initializes events on the product-tile for the following elements:
 * - swatches
 * - thumbnails
 */
function initializeEvents() {
	initQuickViewButtons();
	gridViewButtons();

	if (window.pageContext.ns === 'hampers') {
		hampers.initializeEvents();
	}

	addToCart();
}
/**
 * @desc sync product tiles height on viewport change
 * @param context {string} container of the tiles
 */
function syncTilesHeightOnResize (context) {
	$(window).smartresize(function () {
		var tiles = $('.tiles-container .product-tile');
		if ($(context).hasClass('wide-tiles') || tiles.length === 0) {return;}
			tiles.css('height', 'auto');
			tiles.syncHeight();
	});
}
exports.init = function () {
	// remove not found tiles
	var $notFoundTiles = $('.tiles-container .product-tile-not-found');
	$notFoundTiles.parent('.grid-tile').remove();

	var $tiles = $('.tiles-container .product-tile');
	if ($tiles.length === 0) { return; }
	if (typeof window.imagesLoaded !== 'undefined') {
		// eslint-disable-next-line no-undef
		imagesLoaded('.tiles-container').on('always', function () {
			$tiles.syncHeight()
				.each(function (idx) {
					$(this).data('idx', idx);
				});
		});
	}
	initializeEvents();
};
exports.syncTilesHeightOnResize = syncTilesHeightOnResize;
exports.gridViewToggle = gridViewToggle;